<script>
    export let email;
    export let subject;
    export let body;
    export let label;

    let href = `mailto:${email}`;

    $: href = generateHref(email, subject, body);

    function generateHref(email, subject, body){
        let mailto = `mailto:${email}`;

        if(subject){
            mailto = `${mailto}?subject=${encodeURIComponent(subject)}`;
        }

        if(body){
            mailto = `${mailto}${subject ? '&' : '?'}body=${encodeURIComponent(body)}`;
        }

        return mailto;
    }
</script>

<a {href}>{label}</a>
